import { StoredQuery } from 'src/constants/storedQuery';
import {
  STORED_QUERY_COMPETENCY_QUESTION_IRI,
  SYSTEM_QUERY_CREATOR_IRI,
  SYSTEM_QUERY_DATABASE_IRI,
  SYSTEM_QUERY_DESCRIPTION_IRI,
  SYSTEM_QUERY_IRI,
  SYSTEM_QUERY_NAME_IRI,
  SYSTEM_QUERY_SCHEMA_IRI,
  SYSTEM_QUERY_STRING_IRI,
  SYSTEM_REASONING_QUERY_IRI,
  SYSTEM_SHARED_QUERY_IRI,
  SYSTEM_STORED_QUERY_IRI,
} from 'src/templates/queries/iris';
import { JsonLdResult, JsonLdResults } from 'src/templates/queries/types';

export const serializeStoredQuery = (
  storedQuery: StoredQuery
): JsonLdResults => {
  const serialized: JsonLdResult = {
    '@id': `${SYSTEM_QUERY_IRI}${storedQuery.name}`,
    '@type': [
      SYSTEM_STORED_QUERY_IRI,
      storedQuery.reasoning ? SYSTEM_REASONING_QUERY_IRI : '',
      storedQuery.shared ? SYSTEM_SHARED_QUERY_IRI : '',
    ].filter(Boolean),
  };

  Object.entries({
    [SYSTEM_QUERY_DESCRIPTION_IRI]: storedQuery.description,
    [SYSTEM_QUERY_NAME_IRI]: storedQuery.name,
    [SYSTEM_QUERY_STRING_IRI]: storedQuery.query,
    [SYSTEM_QUERY_CREATOR_IRI]: storedQuery.creator,
    [SYSTEM_QUERY_DATABASE_IRI]: storedQuery.database,
    [STORED_QUERY_COMPETENCY_QUESTION_IRI]: storedQuery.competencyQuestionId,
  })
    .filter((entry): entry is [string, string] => Boolean(entry[1]))
    .forEach(([key, value]) => {
      serialized[key] = { '@value': value };
    });

  // do this separately, since the stored query is set to be a ReasoningQuery automatically if you provide a schema here
  if (storedQuery.reasoning && storedQuery.model) {
    serialized[SYSTEM_QUERY_SCHEMA_IRI] = storedQuery.model;
  }

  return {
    '@graph': [serialized],
  };
};
